import { IContextData } from "../shared/data-context-repository/data-context-repository.models";

export enum kvpMemberEventType {
    valueUpdate = "VALUE_UPDATE",
    valueAdd = "VALUE_ADD"
}

export interface IMemberKeyValueList 
{
    Keys: IMemberKeyValueDto[];
}

export interface IMemberKeyValueDto {
    id?: number;
    memberId?: string;
    key?: string;
    value?: string;
    source?: string;
    createdOn?: Date;
    createdBy?: string;
    modifiedOn?: Date;
    modifiedBy?: string;
}

export interface IMemberKeyEvent  extends IContextData {
    MemberKeyValueDto: IMemberKeyValueDto[];
}

export class EnumItemTyped<T, V> {
    key: T;
    value: V;
    extras?: { [key: string]: any };
}

export class EnumItem<T> extends EnumItemTyped<T, string> {
}

export const yesNoItems: EnumItem<boolean>[] = [
    {
        key: true,
        value: 'Yes',
        extras: { id: 'Y' }
    },
    {
        key: false,
        value: 'No',
        extras: { id: 'N' }
    },
];

export const tenantMemberStatusItems: EnumItem<boolean>[] = [
    {
        key: false,
        value: 'Yes',
        extras: { id: 'Y' }
    },
    {
        key: true,
        value: 'No',
        extras: { id: 'N' }
    },
];

export interface LabelValueLowerGeneric<T> {
    label: string;
    value: T;
}

export interface IdValueLowerGeneric<T> {
    id: string;
    value: T;
}


export interface LabelValueLower extends LabelValueLowerGeneric<string> {
}

export interface IdValueLower extends IdValueLowerGeneric<any> {
}

export interface LabelValueUpperGeneric<T> {
    Label: string;
    Value: T;
}

export interface LabelValueUpper extends LabelValueUpperGeneric<string> {
}
